/**
 * @module
 */

const selector = '[data-js-ny-tack]';
const nyTack = function (el, app) {

    return {
        init: function () { }
    }
};

nyTack.selector = selector;

export default nyTack;
